import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Button, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

import { CONTENT_ACTION_BUTTON_SX } from './ContentActionBar';

interface Props {
  selectedCount: number;
  onClear: () => void;
  onDeleteSelected: () => void;
}

export default function SelectionDeleteBar({ selectedCount, onClear, onDeleteSelected }: Props) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 88,
        right: { xs: 16, lg: 'max(56px, calc(50% - 768px + 56px))' },
        zIndex: 3,
        px: 2,
        py: 1,
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.98),
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: (theme) => `0 10px 32px ${alpha(theme.palette.common.black, 0.12)}`,
        backdropFilter: 'blur(8px)',
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Typography variant="body2" fontWeight={600} whiteSpace="nowrap">
          {`${selectedCount} selected`}
        </Typography>
        <Button variant="text" color="inherit" size="small" onClick={onClear}>
          Clear
        </Button>
        <Button
          variant="contained"
          color="error"
          size="small"
          startIcon={<DeleteIcon />}
          onClick={onDeleteSelected}
          sx={CONTENT_ACTION_BUTTON_SX}
        >
          Delete selected
        </Button>
      </Stack>
    </Box>
  );
}
